// lib/telefonie/anrufZiel.ts
// Sprungziel der Anrufkarte → Route. Getrennt und getestet, weil ein falscher
// Pfad in der Karte erst beim Klicken auffällt. Alle vier Quellen laufen über
// dieselbe Route "/admin/kontakte/:quelle/:id" (siehe App.tsx).
import type { AnrufZiel } from './anrufKarte';

const PFAD: Record<string, (id: string) => string> = {
  mieter: (id) => `/admin/mieter/${id}`,
  eigentuemer: (id) => `/admin/eigentuemer/${id}`,
  kontakt: (id) => `/admin/kontakte/kontakt/${id}`,
  dienstleister: (id) => `/admin/kontakte/dienstleister/${id}`,
};

export function anrufZielPfad(ziel: AnrufZiel): string | null {
  const bauer = PFAD[ziel.typ];
  return bauer ? bauer(ziel.id) : null;
}
